import React from "react";

const PlayerInfo = ({ children }) => (
  <div className="player-info">{children}</div>
);

export default PlayerInfo;
